<svg xmlns="http://www.w3.org/2000/svg" height="48" width="48"><path d="M6 36V33H18V36ZM6 15V12H42V15ZM6 25.5V22.5H30V25.5Z" fill="currentColor"/></svg>
